import { render, staticRenderFns } from "./Privacypolicy.vue?vue&type=template&id=39ad15c3&scoped=true&"
import script from "./Privacypolicy.vue?vue&type=script&lang=js&"
export * from "./Privacypolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad15c3",
  null
  
)

export default component.exports